export default {
    MensagensPushVisualizadas: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "mensagens-push-visualizadas"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/MensagensPushVisualizadas.js
// module id = otyX
// module chunks = 32